import { ReactNode } from 'react';
import { useRouter } from 'next/router';

import { getUserTypeCookie } from '~/features/cookies/utils/get-user-type-cookie';
import { useUserExperience } from '~/features/user/hooks/use-user-experience';
import { useClientRender } from '~/hooks/use-client-render';

/**
 * Only renders content to consumer users who are not subscribed
 */

export function ConsumerContent({
  children,
  fallbackContentSlot = null,
  renderFirst = true,
}: {
  children: ReactNode;
  fallbackContentSlot?: ReactNode;
  renderFirst?: boolean;
}) {
  const isClient = useClientRender();
  const {
    userExperience,
    userExperienceIsFetched,
    userExperienceIsLoading,
    userExperienceIsFetching,
    userExperienceError,
  } = useUserExperience();
  const router = useRouter();
  const hasActiveSubscription = userExperienceIsFetched ? userExperience?.hasActiveSubscription === true : false;
  const isEnterpriseUser = isClient && getUserTypeCookie() === 'enterprise';
  const isBrowsingEnterprise = router.query.companySlug !== undefined;

  const shouldRenderContentSlot =
    userExperienceIsLoading || userExperienceIsFetching || userExperienceError
      ? renderFirst
      : hasActiveSubscription || isBrowsingEnterprise || isEnterpriseUser
        ? false
        : true;

  return <>{shouldRenderContentSlot ? children : fallbackContentSlot}</>;
}
